"use client";

import {
  BlurBackgroundContainer,
  type BlurBackgroundContainerProps,
} from "@/component/BlurBackgroundContainer";
import { useMediaEditorContext } from "@/component/MediaEditorModal/context";
import { useCallback, useMemo } from "react";
import { useMediaPreviewContext } from "../context";
import { MediaPreviewActions } from "./MediaPreviewActions";

interface MediaPreviewContentProps {
  videoPlayerRef?: BlurBackgroundContainerProps["videoPlayerRef"];
}

export function MediaPreviewContent({
  videoPlayerRef,
}: MediaPreviewContentProps) {
  const { mediaType, current } = useMediaPreviewContext();
  const { actions, config } = useMediaEditorContext();

  const handleClipRangeChange = useCallback(
    (startTime: number) => {
      if (!config.isOwner) return;

      actions.onUpdateDraft(
        {
          videoClipStartTime: startTime,
        },
        false
      );
    },
    [actions, config.isOwner]
  );

  const isVideo = mediaType === "video" || mediaType === "avatar";
  const duration = current.shotDuration || 0;
  const startTime = current.videoClipStartTime ?? 0;

  const clipRange = useMemo(() => {
    return isVideo && duration > 0 ? { startTime, duration } : undefined;
  }, [isVideo, startTime, duration]);

  return (
    <>
      <BlurBackgroundContainer
        mediaType={mediaType === "image" ? "image" : "video"}
        src={current.src}
        previewSrc={current.previewSrc}
        height="100%"
        alt="preview"
        className="w-full h-full"
        videoPlayerRef={videoPlayerRef}
        enableClipRange={isVideo}
        clipRange={clipRange}
        onClipRangeChange={handleClipRangeChange}
        enablePreview
      />

      <MediaPreviewActions />
    </>
  );
}
